import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import type { ShopProductCatalogInitData } from './types';
import './style.css';

const MOUNT_ID = 'gas-shop-product-catalog-app';

const mountEl = document.getElementById(MOUNT_ID);

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: ShopProductCatalogInitData;

    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as ShopProductCatalogInitData;
    } catch (error) {
        if (window.console && window.console.error) {
            window.console.error('[gas-shop-product-catalog] init JSON invalide', error);
        }
        initData = {};
    }

    try {
        createRoot(mountEl).render(
            <React.StrictMode>
                <App initData={initData} />
            </React.StrictMode>,
        );
    } catch (error) {
        // En cas d'échec du mount React, le HTML statique rendu par PHP
        // restera disponible tant que React ne remplace pas le contenu.
        if (window.console && window.console.error) {
            window.console.error('[gas-shop-product-catalog] mount KO', error);
        }
    }
}
